import { useHttpClientDispatchable } from "../../../common/modules/httpClient/hooks/useHttpClientDispatchable";
import { RequestMethodEnum } from "../../../common/modules/httpClient/enums/RequestMethodEnum";

export const useUpdateSprintService = (props: { sprintId: number }) => {
  return useHttpClientDispatchable({
    url: `/sprint/${props.sprintId}`,
    method: RequestMethodEnum.PUT,
  });
};
